/**
 * Set DevExtreme theme as early as possible (no other imports).
 * Must be imported first in index.js so it runs before any dxDataGrid usage (avoids E0021).
 */
if (typeof window !== "undefined" && window.DevExpress) {
  try {
    if (window.DevExpress.config) {
      window.DevExpress.config({ theme: "light.compact" });
    }
    if (window.DevExpress.ui?.themes?.current) {
      window.DevExpress.ui.themes.current("light.compact");
    }
  } catch (_) {}
}
